<h2 mat-dialog-title class="mat-dialog-title-offset">{{data.timeLocked ? 'Please select a session block' : 'Session Date Picker'}}</h2>

<div class="modal-close-icon-container tw:flex tw:items-center">
  <button class="close-modal" mat-button (click)="closeDialog(false)" tabindex='-1'>
    <div class="close-modal modal-close-icon">
    </div>
  </button>
</div>

<mat-dialog-content class="mat-typography modal-master-container tw:mx-2 tw:flex tw:justify-center tw:items-center">

  <div class="tw:w-full tw:p-4 tw:m-0 tw:mt-auto content-container">

    @if (!data.timeLocked) {
      <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
        <div class="tw:w-full tw:px-[15px] tw:md:w-2/3">
          <form [formGroup]="frmSessionDatePicker" novalidate>
            <div class="flex-row">
              <div class="flex-column">
                <label>Date</label>
                <input type="date" class="field__control" id="startDate" required
                  formControlName="startDate" (change)="getExternalSession()">
                @if (frmSessionDatePicker.controls.startDate.errors && frmSessionDatePicker.controls.startDate.errors.key) {
                  <span class="field__error">Date should be between {{ minDate | date : 'dd/MM/yyyy'}} and {{maxDate | date : 'dd/MM/yyyy'}}</span>
                }
                @if (frmSessionDatePicker.controls.startDate.hasError('noSessionAvailable')) {
                  <span class="field__error">{{startDateErrorMessage}}</span>
                }
                </div>
              </div>
              <div class="flex-row">
                <div class="flex-column">
                  <label>Start</label>
                  <input class="field__control body-content" formControlName="startTime" type="time" step="300"
                    required [readonly]="placementData?.lockTime"
                    (change)="updateDurationDisplay('change')" />
                  @if (frmSessionDatePicker.controls.startTime.hasError('StartTimeCannotBeLaterThanEndTime')) {
                    <span class="field__error">Start time cannot be equal to or after end time</span>
                  }
                  </div>
                </div>
                <div class="flex-row">
                  <div class="flex-column">
                    <label>Finish</label>
                    <input class="field__control body-content" formControlName="endTime" type="time" step="300"
                      required [readonly]="placementData?.lockTime"
                      (change)="updateDurationDisplay('change')" />
                    @if (frmSessionDatePicker.controls.endTime.hasError('EndTimeCannotBeEarlierThanStartTime')) {
                      <span class="field__error">End time cannot be earlier than Start time</span>
                    }
                    </div>
                  </div>
                </form>
              </div>
              <div class="tw:w-full tw:px-[15px] tw:md:w-1/3">
                <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:h-full tw:justify-center tw:items-center">
                  <div class="tw:w-full tw:px-[15px]">
                    <label>Session day - {{selectedDay}}</label>
                    <br />
                    <label>Session duration - {{sessionDuration}}</label>
                  </div>
                </div>
              </div>
            </div>
          }

          @if (data.timeLocked) {
            <div>
              <div class="tw:flex tw:flex-wrap tw:p-0 tw:m-0">
                <div class="tw:w-full tw:p-0 tw:m-0 tw:text-center">
                  @if (data.method == 'Update') {
                    <div>
                      <h3>Current session block - <span class="text-primary-colour">{{data.startDate | date: 'dd MMM yyyy'}} {{data.startTime.length > 5 ? data.startTime.slice(0, -3) : data.startTime}} to
                      {{data.endTime.length > 5 ? data.endTime.slice(0, -3) : data.endTime}}</span></h3>
                    </div>
                  }
                </div>
              </div>
              <div class="tw:flex tw:flex-wrap tw:p-0 tw:m-0">
                <div class="tw:w-1/12 tw:p-0 tw:m-0">
                  <a class="carousel-control-prev cursor-pointer" (click)="sessionBlockChange('previous')" data-slide="prev"
                    [ngClass]="{'disabled-link': sessionBlockPageNumber == 1}">
                    <span class="carousel-control-prev-icon"></span>
                  </a>
                </div>
                <div class="tw:w-10/12 tw:p-0 tw:m-0">
                  <div class="tw:flex tw:flex-wrap tw:p-0 tw:m-0 tw:justify-center tw:items-center">
                    @for (sessionBlock of sessionBlocks; track sessionBlock; let i = $index) {
                      <div class="tw:w-full tw:px-[15px] tw:my-6 tw:text-center" [ngClass]="{'tw:xl:w-1/4': showMore, 'tw:xl:w-1/3': !showMore}"
                        >
                        <div class="tw:p-6"
                          [ngClass]="{'session-block-disabled': sessionBlock.disabled && !sessionBlock.selected, 'session-block-item': !sessionBlock.disabled && !sessionBlock.selected, 'session-block-selected': sessionBlock.selected  }"
                          (click)="selectSessionBlock(sessionBlock, i)">
                          <div class="tw:mb-2">
                            <app-session-status-pill [status]="sessionBlock.status"></app-session-status-pill>
                          </div>
                          <div class="tw:flex tw:flex-wrap tw:-mx-[15px]"
                            [ngClass]="{'cursor-not-allowed': sessionBlock.disabled, 'cursor-pointer': !sessionBlock.disabled }">
                            <div class="tw:flex-1 tw:px-[15px]"
                              [ngClass]="{'cursor-not-allowed': sessionBlock.disabled, 'cursor-pointer': !sessionBlock.disabled }">
                              <label class="session-block-label"
                              [ngClass]="{'cursor-not-allowed': sessionBlock.disabled, 'cursor-pointer': !sessionBlock.disabled }">{{setDisplaySessionBlockDay(sessionBlock.startDate)}}</label>
                            </div>
                          </div>
                          <div class="tw:flex tw:flex-wrap tw:-mx-[15px]"
                            [ngClass]="{'cursor-not-allowed': sessionBlock.disabled, 'cursor-pointer': !sessionBlock.disabled }">
                            <div class="tw:flex-1 tw:px-[15px]"
                              [ngClass]="{'cursor-not-allowed': sessionBlock.disabled, 'cursor-pointer': !sessionBlock.disabled }">
                              <label class="session-block-label"
                                [ngClass]="{'cursor-not-allowed': sessionBlock.disabled, 'cursor-pointer': !sessionBlock.disabled }">{{sessionBlock.startDate
                              | date: 'dd MMMM'}}</label>
                            </div>
                          </div>
                          <div class="tw:flex tw:flex-wrap tw:-mx-[15px]"
                            [ngClass]="{'cursor-not-allowed': sessionBlock.disabled, 'cursor-pointer': !sessionBlock.disabled }">
                            <div class="tw:flex-1 tw:px-[15px]"
                              [ngClass]="{'cursor-not-allowed': sessionBlock.disabled, 'cursor-pointer': !sessionBlock.disabled }">
                              <label class="session-block-label"
                                [ngClass]="{'cursor-not-allowed': sessionBlock.disabled, 'cursor-pointer': !sessionBlock.disabled }">{{sessionBlock.startDate
                                | date:
                              'yyyy'}}</label></div>
                            </div>
                            <div class="tw:flex tw:flex-wrap tw:-mx-[15px]"
                              [ngClass]="{'cursor-not-allowed': sessionBlock.disabled, 'cursor-pointer': !sessionBlock.disabled }">
                              <div class="tw:flex-1 tw:px-[15px]"
                                [ngClass]="{'cursor-not-allowed': sessionBlock.disabled, 'cursor-pointer': !sessionBlock.disabled }">
                                <label class="session-block-label"
                                  [ngClass]="{'cursor-not-allowed': sessionBlock.disabled, 'cursor-pointer': !sessionBlock.disabled }">{{sessionBlock.startTime.length
                                  >
                                  5 ?
                                  sessionBlock.startTime.slice(0, -3) : sessionBlock.startTime}} -
                                  {{sessionBlock.endTime.length > 5 ? sessionBlock.endTime.slice(0, -3) :
                                sessionBlock.endTime}}</label></div>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                    <div class="tw:w-1/12 tw:p-0 tw:m-0">
                      <a class="carousel-control-next cursor-pointer" (click)="sessionBlockChange('next')" data-slide="prev"
                        [ngClass]="{'disabled-link': lastSessionBlockPage}">
                        <span class="carousel-control-next-icon"></span>
                      </a>
                    </div>
                  </div>
                  <div class="tw:flex tw:flex-wrap tw:p-0 tw:m-0">
                    <div class="tw:w-full tw:p-0 tw:m-0">
                      <div class="div-flex-buttons tw:justify-center tw:items-center">
                        <button mat-button tabindex="-1" (click)="triggerShowMore()"
                        class="btn btn-outline-primary tw:my-1 tw:mx-1 small-device-hidden">{{showMore ? 'Show Less' : 'Show More'}}</button>
                      </div>
                    </div>
                  </div>
                  <div class="tw:flex tw:flex-wrap tw:p-0 tw:pt-2 tw:m-0">
                    @if (frmSessionDatePicker.controls.startTime.hasError('StartTimeCannotBeLaterThanEndTime')) {
                      <div class="tw:w-full tw:px-[15px] tw:text-center">
                        <label class="tw:text-danger">Start time cannot be equal to or after end time</label>
                      </div>
                    }
                    @if (frmSessionDatePicker.controls.startDate.errors && frmSessionDatePicker.controls.startDate.errors.key) {
                      <div class="tw:w-full tw:px-[15px] tw:text-center">
                        @if (!maxDateLessThanMinDate) {
                          <label class="tw:text-danger">Date should be between {{ minDate | date : 'dd/MM/yyyy'}} and {{maxDate | date :
                          'dd/MM/yyyy'}}</label>
                        }
                        @if (maxDateLessThanMinDate) {
                          <label class="tw:text-danger">Sessions are too far in advance to allow for entry </label>
                        }
                      </div>
                    }
                    @if (frmSessionDatePicker.controls.startDate.hasError('noSessionAvailable')) {
                      <div class="tw:w-full tw:px-[15px] tw:text-center">
                        <label class="tw:text-danger">{{startDateErrorMessage}}</label>
                      </div>
                    }
                    @if (frmSessionDatePicker.controls.endTime.hasError('EndTimeCannotBeEarlierThanStartTime')) {
                      <div class="tw:w-full tw:px-[15px] tw:text-center">
                        <label class="tw:text-danger">End time cannot be earlier than Start time</label>
                      </div>
                    }
                  </div>
                </div>
              }

            </div>

          </mat-dialog-content>

          <mat-dialog-actions class="div-flex-buttons">
            <div class="div-flex-buttons tw:justify-start tw:items-start">
              <button mat-button (click)="closeDialog(false)" class="btn btn-outline-primary tw:my-1 tw:mx-1 tw:float-left"
              tabindex="-1">Cancel</button>
              <button mat-button (click)="clearResetDates()" class="btn btn-outline-primary tw:my-1 tw:mx-1 tw:float-left"
              tabindex="-1">{{data.method == 'Add' ? 'Clear' : 'Reset'}}</button>
            </div>
            <div class="div-flex-buttons tw:justify-end tw:items-end">
              <button mat-button (click)="closeDialog(true)" class="btn btn-primary tw:my-1 tw:mx-1 tw:float-right"
              [disabled]="frmSessionDatePicker.status == 'INVALID' || disableConfirm">Confirm</button>
            </div>
          </mat-dialog-actions>
